import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {DocumentSummaryModel} from '../../model/documentSummary.model';
import {AuthService} from '../../../../../auth/api/service/auth.service';
import {Subscription} from 'rxjs';
import {DocumentDownloadComponent} from '../document-download/document-download.component';
import {DocumentSummaryFindOneByIdService} from "../../service/documentSummaryFindOneById.service";
import {
    IconFile,
} from "angular-tabler-icons/icons";
import {TablerIconsProvider} from "angular-tabler-icons";
@Component({
    selector: 'app-document-summary-field',
    templateUrl: './document-summary-field.component.html',
    providers: [
        DocumentSummaryFindOneByIdService,
        TablerIconsProvider.pick({IconFile})
    ]
})
export class DocumentSummaryModelFieldComponent implements OnInit, OnDestroy, OnChanges {

    @Input() documentId: number;
    @Input() documentSummary: DocumentSummaryModel;
    @Input() label: string;
    @ViewChild('documentDownload') documentDownloadComponent: DocumentDownloadComponent;

    token: string;
    subscription: Subscription;

    constructor(private authService: AuthService,
                public findOneByIdService: DocumentSummaryFindOneByIdService) {
        this.subscription = this.authService.tokenContent$.subscribe(value => this.token = value.token);
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['documentId'] && this.documentId) {
            this.findOneByIdService.loadEntity(this.documentId)
                .then((value) => this.documentSummary = value);
        }
    }

    show() {
        this.documentDownloadComponent.execute();
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }
}
